jQuery(document).ready(function() {
  if ( jQuery('body.woocommerce-checkout').length ) {
    (function ($) {
      $(document).ready(function () {
        ( "Loading thing" );

        var shipping_alt = $("#shipping_alt");
        var billing_alt = $("#billing_alt");

        shipping_alt.val("0");
        billing_alt.val("0");

        $(document).delegate('#shipping_alt', "change", function () {
          ( "AAAAAA CHANGE" );
          $.post(
            WCMA_Ajax.ajaxurl, {
              action               : 'alt_change',
              id                   : $(this).val(),
              wc_multiple_addresses: WCMA_Ajax.wc_multiple_addresses
            }, function (response) {
              $('#shipping_address_1').val(response.shipping_address_1);
              $('#shipping_address_2').val(response.shipping_address_2);
              $('#shipping_phone').val(response.shipping_phone);
              $('#shipping_email').val(response.shipping_email);
              $('#shipping_city').val(response.shipping_city);
              $('#shipping_company').val(response.shipping_company);
              $('#shipping_country').val(response.shipping_country).change();
              $("#shipping_country_chosen").find('span').html(response.shipping_country_text);
              $('#shipping_first_name').val(response.shipping_first_name);
              $('#shipping_last_name').val(response.shipping_last_name);
              $('#shipping_postcode').val(response.shipping_postcode);
              $('#shipping_state').val(response.shipping_state);
              var stateName = $('#shipping_state option[value="'+response.shipping_state+'"]').text();
                        $("#s2id_shipping_state").find('.select2-chosen').html(stateName).parent().removeClass('select2-default');
            }
          );
          return false;
        });

        $(document).delegate('#billing_alt', "change", function () {
          ( "BBBBBB CHANGE" );
          $.post(
            WCMA_Ajax.ajaxurl, {
              action               : 'alt_change',
              id                   : $(this).val(),
              wc_multiple_addresses: WCMA_Ajax.wc_multiple_addresses
            }, function (response) {
              $('#billing_address_1').val(response.shipping_address_1);
              $('#billing_address_2').val(response.shipping_address_2);
              $('#billing_phone').val(response.shipping_phone);
              $('#billing_email').val(response.shipping_email);
              $('#billing_city').val(response.shipping_city);
              $('#billing_company').val(response.shipping_company);
              $('#billing_country').val(response.shipping_country).change();
              $("#billing_country_chosen").find('span').html(response.shipping_country_text);
              $('#billing_first_name').val(response.shipping_first_name);
              $('#billing_last_name').val(response.shipping_last_name);
              $('#billing_postcode').val(response.shipping_postcode);
              $('#billing_state').val(response.shipping_state);
              var stateName = $('#billing_state option[value="'+response.shipping_state+'"]').text();
              $("#s2id_billing_state").find('.select2-chosen').html(stateName).parent().removeClass('select2-default');
            }
          );
          return false;
        });


        // wc_country_select_params is required to continue, ensure the object exists
        if ( typeof wc_country_select_params === 'undefined' ) {
          return false;
        }

        /* State/Country select boxes */
        var states_json = wc_country_select_params.countries.replace( /&quot;/g, '"' ),
          states = $.parseJSON( states_json );

        $(document).on("change", "select.country_to_state, input.country_to_state", function () {
          ( "CCCCCC CHANGE" );
          var country = $( this ).val(),
            $statebox = $( this ).closest( 'div' ).find( '#billing_state, #shipping_state, #calc_shipping_state' ),
            $parent = $statebox.parent(),
            input_name = $statebox.attr( 'name' ),
            input_id = $statebox.attr( 'id' ),
            value = $statebox.val(),
            placeholder = $statebox.attr( 'placeholder' );

          if ( states[ country ] ) {
            if ( states[ country ].length === 0 ) {

              $statebox.parent().hide().find( '.chosen-container' ).remove();
              $statebox.replaceWith( '<input type="hidden" class="hidden" name="' + input_name + '" id="' + input_id + '" value="" placeholder="' + placeholder + '" />' );

              $( 'body' ).trigger( 'country_to_state_changed', [country, $( this ).closest( 'div' )] );

            } else {

              var options = '',
                state = states[ country ];

              for( var index in state ) {
                if ( state.hasOwnProperty( index ) ) {
                  options = options + '<option value="' + index + '">' + state[ index ] + '</option>';
                }
              }

              $statebox.parent().show();

              if ( $statebox.is( 'input' ) ) {
                // Change for select
                $statebox.replaceWith( '<select name="' + input_name + '" id="' + input_id + '" class="state_select" placeholder="' + placeholder + '"></select>' );
                $statebox = $( this ).closest( 'div' ).find( '#billing_state, #shipping_state, #calc_shipping_state' );
              }

              $statebox.html( '<option value="">' + wc_country_select_params.i18n_select_state_text + '</option>' + options );

              $statebox.val( value );

              $( 'body' ).trigger( 'country_to_state_changed', [country, $( this ).closest( 'div' )] );

            }
          } else {
            if ( $statebox.is( 'select' ) ) {

              $parent.show().find( '.chosen-container' ).remove();
              $statebox.replaceWith( '<input type="text" class="input-text" name="' + input_name + '" id="' + input_id + '" placeholder="' + placeholder + '" />' );

              $( 'body' ).trigger( 'country_to_state_changed', [country, $( this ).closest( 'div' )] );

            } else if ( $statebox.is( '.hidden' ) ) {

              $parent.show().find( '.chosen-container' ).remove();
              $statebox.replaceWith( '<input type="text" class="input-text" name="' + input_name + '" id="' + input_id + '" placeholder="' + placeholder + '" />' );

              $( 'body' ).trigger( 'country_to_state_changed', [country, $( this ).closest( 'div' )] );

            }
          }

          $( 'body' ).trigger( 'country_to_state_changing', [country, $( this ).closest( 'div' )] );

        }).change();

      });
    })(jQuery);

    jQuery('select#billing_alt').select2();
    jQuery('select#shipping_alt').select2();

    jQuery('body').on('click','#place_order',function(event) {
      if ( jQuery('.smarty-tag:not(.smarty-tag-green):visible').length ) {
        var confirm = window.confirm( "You have not verified your address, an unverified address may result in delivery failure, please confirm you wish to continue checkout without verifying your address, or click cancel and verify your address by pressing the check icon button next to the zip code." );
        if ( !confirm ) event.preventDefault();
      }
    });

    function permute(input, permArr, usedChars) {
      var i, ch;
      for (i = 0; i < input.length; i++) {
        ch = input.splice(i, 1)[0];
        usedChars.push(ch);
        if (input.length === 0) {
          permArr.push(usedChars.slice());
        }
        permute(input, permArr, usedChars);
        input.splice(i, 0, ch);
        usedChars.pop();
      }
      return permArr;
    }

    jQuery( document.body ).on('country_to_state_changed', function() {
      if ( jQuery('.state_select option[value=""]').length ) {
        jQuery('.state_select option[value=""]').each(function(i,v){
          jQuery(this).find('option:nth-child(2)').attr('selected', 'selected');
        })
      }
    })

    jQuery('.state_select').select2({
      matcher: function(term, text) {

        if (term.length === 0) return true;
        texts = text.split(" ");

        allCombinations = permute(texts, [], []);

        for (i in allCombinations) {
          if (allCombinations[i].join(" ").toUpperCase().indexOf(term.toUpperCase()) === 0) {
            return true;
          }
        }
        return false;
      }
    });

    $('#account_password').keyup(function() {
      if ( $(this).val() != '' )
        $('#createaccount').prev('checked',true);
      else
        $('#createaccount').prev('checked',false);
    });
  }
});